import clsx from 'clsx';
import { TemplateCardHeader } from './components/TemplateCardHeader';
import { TemplateCardBody } from './components/TemplateCardBody';
import { TemplateCardFooter } from './components/TemplateCardFooter';
import styles from './TemplateCard.module.css';

export function TemplateCard({
  templateId = null,
  status,
  channel,
  language = null,
  updatedLabel,
  title,
  type,
  trigger = null,
  tags = [],
  campaigns = [],
  showActions = false,
  canEdit = false,
  onEdit,
  onCopy,
  onPreview,
}) {
  return (
    <article className={clsx(styles.card)} aria-label="Template">
      <div className={clsx(styles.main)}>
        <TemplateCardHeader
          status={status}
          channel={channel}
          language={language}
          updatedLabel={updatedLabel}
          showActions={showActions}
          canEdit={canEdit}
          onEdit={onEdit}
          onCopy={onCopy}
          onPreview={onPreview}
        />

        <TemplateCardBody templateId={templateId} title={title} tags={tags} />
      </div>

      <TemplateCardFooter type={type} trigger={trigger} status={status} campaigns={campaigns} />
    </article>
  );
}
